var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchElasticFabricAdapter32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Elastic-Fabric-Adapter_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8511B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Elastic-Fabric-Adapter_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/Elastic-Fabric-Adapter_32",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.819,11.295 L4.889,10.927 C6.65,6.484 11.116,3.5 16,3.5 C20.883,3.5 25.349,6.484 27.11,10.927 L26.18,11.295 C24.569,7.231 20.477,4.5 16,4.5 C11.522,4.5 7.43,7.231 5.819,11.295 L5.819,11.295 Z M26.176,19.233 L27.114,19.581 C25.355,24.318 20.888,27.5 16,27.5 C11.111,27.5 6.644,24.318 4.885,19.581 L5.823,19.233 C7.437,23.58 11.527,26.5 16,26.5 C20.472,26.5 24.562,23.58 26.176,19.233 L26.176,19.233 Z M29,16.776 C29,16.898 28.897,17 28.776,17 L25.223,17 C25.102,17 25,16.898 25,16.776 L25,13.224 C25,13.103 25.102,13 25.223,13 L28.776,13 C28.897,13 29,13.103 29,13.224 L29,16.776 Z M28.776,12 L25.223,12 C24.548,12 24,12.549 24,13.224 L24,16.776 C24,17.451 24.548,18 25.223,18 L28.776,18 C29.451,18 30,17.451 30,16.776 L30,13.224 C30,12.549 29.451,12 28.776,12 L28.776,12 Z M3,16.776 L3,13.224 C3,13.103 3.102,13 3.223,13 L6.776,13 C6.897,13 7,13.103 7,13.224 L7,16.776 C7,16.898 6.897,17 6.776,17 L3.223,17 C3.102,17 3,16.898 3,16.776 L3,16.776 Z M8,16.776 L8,13.224 C8,12.549 7.451,12 6.776,12 L3.223,12 C2.548,12 2,12.549 2,13.224 L2,16.776 C2,17.451 2.548,18 3.223,18 L6.776,18 C7.451,18 8,17.451 8,16.776 L8,16.776 Z M17,15 L19,15 L19,14 L17,14 L17,15 Z M13,15 L16,15 L16,14 L13,14 L13,15 Z M12,16 L20,16 L20,13 L12,13 L12,16 Z M15,18 L15,19 L11,19 L11,18 L10,18 L10,11 L22,11 L22,18 L20,18 L20,19 L18,19 L18,18 L15,18 Z M21,20 L21,19 L23,19 L23,10 L9,10 L9,19 L10,19 L10,20 L16,20 L16,19 L17,19 L17,20 L21,20 Z",
    id: "Fill-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchElasticFabricAdapter32);
export default __webpack_public_path__ + "static/media/Arch_Elastic-Fabric-Adapter_32.5a87ea5f3d7586980238ed6ba864ef2f.svg";
export { ForwardRef as ReactComponent };